import { render } from "./Work.vue?vue&type=template&id=dc91050a&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=dc91050a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc91050a"]])

export default __exports__